import React, { useState, useEffect } from 'react';
import { Button, Checkbox, Dropdown, Menu } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import pickBy from 'lodash/pickBy';
import size from 'lodash/size';
import { ReactComponent as Arrow } from '../../../images/arrow_down.svg';
import { ReactComponent as AvalibleLock } from '../../../images/lock_green_close.svg';
import { ReactComponent as NotAvalibleLock } from '../../../images/lock_gray_close.svg';
import { ReactComponent as OpenLockBlue } from '../../../images/lock_blue_open.svg';
import { ReactComponent as OpenLockGreen } from '../../../images/lock_green_open.svg';
import { ReactComponent as Circle } from '../../../images/circle.svg';
import { ReactComponent as DontatacchedIcon } from '../../../images/dontatacched.svg';
const Wrapper = styled.div`
  &&& {
    #area {
      .ant-dropdown-menu {
        padding: 0 !important;
        padding-top: 20px !important;
        padding-bottom: 10px !important;
      }
      .ant-dropdown-menu-item {
        padding: 0;
      }
      position: relative;
      div {
        &:nth-child(1) {
          top: 16px !important;
          z-index: 1;
          .ant-dropdown-menu {
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            padding: 22px 0;
            padding-left: 18px;
            box-shadow: 0px 11px 12px rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }
`;

const Item = styled.div`
  &&& {
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-left: 18px;
    padding-top: 6px;
    padding-bottom: 6px;
    .ant-checkbox-input {
      border-radius: 4px;
    }
    svg {
      margin: 0 17px;
    }
  }
`;

function FilterBox({ getBoxes, storageId  }) {
  const [visible, setVisible] = useState(false);
  const {t} = useTranslation();
  const [params, setParams] = useState({
    available: false,
    notAvailable: false,
    expired: false,
    attached: false,
    openTenant: false,
    openAdmin: false,
  });
  const [choose, setChoose] = useState(null);

  useEffect(() => {
    const result = pickBy(params, function (value, key) {
      return value === true;
    });
    setChoose(size(result));
    if (
      params.available ||
      params.expired ||
      params.notAvailable ||
      params.openTenant ||
      params.openAdmin ||
      params.attached
    ) {
      getBoxes({
        available: [
          params.available ? 1 : null,
          params.notAvailable ? 0 : null,
        ],
        expired: params.expired ? 1 : null,
        device_id__is_null: params.attached ? 1 : null,
        warehouse_id: storageId,
        device__telemetry__source: [
          params.openTenant ? 'button' : null,
          params.openAdmin ? 'backend' : null,
        ],
      });
    } else if (choose !== null) {
      getBoxes();
    }
  }, [params]);

  const Available = () => (
    <Item
      onClick={() => {
        setParams({ ...params, available: !params.available });
      }}
    >
      <Checkbox checked={params.available} /> <AvalibleLock /> {t('boxAvailable')}
    </Item>
  );

  const NotAvailable = () => (
    <Item
      onClick={() => {
        setParams({ ...params, notAvailable: !params.notAvailable });
      }}
    >
      <Checkbox checked={params.notAvailable} /> <NotAvalibleLock /> {t('rented')}
    </Item>
  );

  const OpenTenant = () => (
    <Item
      onClick={() => {
        setParams({ ...params, openTenant: !params.openTenant });
      }}
    >
      <Checkbox checked={params.openTenant} /> <OpenLockBlue /> {t('openTenant')}
    </Item>
  );

  const OpenAdmin = () => (
    <Item
      onClick={() => {
        setParams({ ...params, openAdmin: !params.openAdmin });
      }}
    >
      <Checkbox checked={params.openAdmin} />
      <OpenLockGreen /> {t('openedByAdministrator')}
    </Item>
  );

  const Delay = () => (
    <Item
      onClick={() => {
        setParams({ ...params, expired: !params.expired });
      }}
    >
      <Checkbox checked={params.expired} /> <Circle /> {t('delay')}
    </Item>
  );

  const Dontatacched = () => (
    <Item
      onClick={() => {
        setParams({ ...params, attached: !params.attached });
      }}
    >
      <Checkbox checked={params.attached} /> <DontatacchedIcon /> {t('dontAttached')}
    </Item>
  );

  const menu = (
    <Menu className="pl-5">
      <Menu.Item key="0">
        <Available />
      </Menu.Item>
      <Menu.Item key="1">
        <NotAvailable />
      </Menu.Item>
      <Menu.Item key="2">
        <OpenTenant />
      </Menu.Item>
      <Menu.Item key="3">
        <OpenAdmin />
      </Menu.Item>
      <Menu.Item key="4">
        <Delay />
      </Menu.Item>
      <Menu.Item key="5">
        <Dontatacched />
      </Menu.Item>
      <Button
        onClick={() => {
          reset();
        }}
        type="primary"
        className="pl-10"
        type="link"
      >
        <span
          style={{ borderBottom: '1px dotted #4b97e9', marginLeft: '11px' }}
        >
          {t('resetAll')}
        </span>
      </Button>
    </Menu>
  );

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const reset = () => {
    setParams({
      available: false,
      notAvailable: false,
      expired: false,
      attached: false,
      openTenant: false,
      openAdmin: false,
    });
  };

  return (
    <Wrapper>
      <div id="area"></div>
      <Dropdown
        className="w-full bg-white shadow-standart rounded-md flex h-45 items-center pl-15 text-graytext relative"
        icon={<Arrow />}
        onVisibleChange={handleVisibleChange}
        visible={visible}
        getPopupContainer={() => document.getElementById('area')}
        overlay={menu}
        trigger={['click']}
      >
        <a
          className="ant-dropdown-link hover:text-graytext"
          onClick={(e) => e.preventDefault()}
        >
          {t('filter')}: <span className="pl-10 text-black font-bold">({choose})</span>
          <Arrow className="absolute right-18" />
        </a>
      </Dropdown>
    </Wrapper>
  );
}

FilterBox.propTypes = {};

export default FilterBox;
